export default "<div class=\"ui text segment\">\r\n    <h2 class=\"ui header\"><i class=\"list icon\"></i>{{esperienza.id}}-{{esperienza.title}}</h2>\r\n</div>"